import { proxy } from 'valtio';

const menschenTimebarState = proxy({
  areaActive: false,
  splinePoint: 1,
});

export default menschenTimebarState;
